import { Box, Container, Grid } from "@mui/material";
import { TabPanelChildrenContainer } from "../styled";
import useIsMobile from "../../../hooks/useIsMobile";

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  const mobile = useIsMobile();

  if (value !== index) return null;
  
  return (
    <Grid
      disableGutters
      sx={{
        overflow: 'hidden', 
        backgroundColor: `transparent`,
        position: 'relative',
        display: (value !== index) && 'none',
        margin: '0!important',
        width: '100%'
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <TabPanelChildrenContainer disableGutters>
          {children}
        </TabPanelChildrenContainer>
      )}
    </Grid>
  );
};

export default CustomTabPanel;